import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("d2-container", [_c("wlc-breadcrumb"), _c("el-form", {
    attrs: {
      inline: true,
      model: _vm.searchForm,
      size: "small"
    }
  }, [_c("el-form", {
    attrs: {
      inline: true,
      model: _vm.searchForm,
      size: "small"
    },
    nativeOn: {
      submit: function submit($event) {
        $event.preventDefault();
      }
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "手机号"
    }
  }, [_c("el-input", {
    nativeOn: {
      keyup: function keyup($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.getData("search");
      }
    },
    model: {
      value: _vm.searchForm.phone,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "phone", $$v);
      },
      expression: "searchForm.phone"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "用户名"
    }
  }, [_c("el-input", {
    nativeOn: {
      keyup: function keyup($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.getData("search");
      }
    },
    model: {
      value: _vm.searchForm.name,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "name", $$v);
      },
      expression: "searchForm.name"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "备注"
    }
  }, [_c("el-input", {
    nativeOn: {
      keyup: function keyup($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.getData("search");
      }
    },
    model: {
      value: _vm.searchForm.remark,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "remark", $$v);
      },
      expression: "searchForm.remark"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "类型"
    }
  }, [_c("el-select", {
    attrs: {
      clearable: ""
    },
    on: {
      change: function change($event) {
        return _vm.getData("search");
      }
    },
    model: {
      value: _vm.searchForm.type,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "type", $$v);
      },
      expression: "searchForm.type"
    }
  }, _vm._l(_vm.typeList, function (item) {
    return _c("el-option", {
      key: item.value,
      attrs: {
        label: item.label,
        value: item.value
      }
    });
  }), 1)], 1), _c("el-form-item", {
    attrs: {
      label: "等级"
    }
  }, [_c("el-select", {
    attrs: {
      clearable: ""
    },
    on: {
      change: function change($event) {
        return _vm.getData("search");
      }
    },
    model: {
      value: _vm.searchForm.level,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "level", $$v);
      },
      expression: "searchForm.level"
    }
  }, _vm._l(_vm.levelList, function (item) {
    return _c("el-option", {
      key: item.value,
      attrs: {
        label: item.label,
        value: item.value
      }
    });
  }), 1)], 1), _c("el-form-item", [_c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: function click($event) {
        return _vm.getData("search");
      }
    }
  }, [_vm._v("搜索 ")]), _c("el-button", {
    attrs: {
      type: "warning"
    },
    on: {
      click: _vm.resetTable
    }
  }, [_vm._v("重置 ")])], 1), _c("el-form-item", [_c("el-button", {
    attrs: {
      type: "success"
    },
    on: {
      click: _vm.add
    }
  }, [_vm._v("新增城市大使 ")]), _c("el-button", {
    attrs: {
      type: "primary",
      size: "small"
    },
    on: {
      click: function click($event) {
        return _vm.$router.push("/user/city-master/settlement-rules");
      }
    }
  }, [_vm._v("结算规则 ")]), _c("el-button", {
    attrs: {
      type: "primary",
      size: "small"
    },
    on: {
      click: function click($event) {
        return _vm.$router.push("/user/city-master/settlement");
      }
    }
  }, [_vm._v("结算历史 ")])], 1)], 1)], 1), _c("el-table", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.tableLoading,
      expression: "tableLoading"
    }],
    ref: "table",
    attrs: {
      data: _vm.tableData,
      border: ""
    },
    on: {
      "sort-change": _vm.sortChange
    }
  }, [_c("el-table-column", {
    attrs: {
      prop: "name",
      label: "姓名",
      width: "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var userInfo = _ref.row.userInfo;
        return [_c("wlc-user-pop", {
          attrs: {
            info: userInfo
          },
          on: {
            saveRemark: _vm.saveRemark
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "user_phone",
      label: "手机号",
      width: "120"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "type",
      label: "类型",
      width: "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.type === "city_master" ? _c("span", [_vm._v("城市大使")]) : _vm._e(), scope.row.type === "school_master" ? _c("span", [_vm._v("校园大使")]) : _vm._e(), scope.row.type === "operation" ? _c("span", [_vm._v("运营")]) : _vm._e()];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "level",
      label: "等级",
      width: "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        var _scope$row;
        return [_vm._v(" " + _vm._s(_vm.level[(_scope$row = scope.row) === null || _scope$row === void 0 ? void 0 : _scope$row.level] || "") + " ")];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      width: "110",
      label: "实名信息"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("RealNameRecords", {
          attrs: {
            info: scope.row
          },
          on: {
            reload: _vm.getData
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "remark",
      label: "备注",
      "min-width": "180"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "invitation_success_rate",
      label: "准确率",
      width: "110",
      sortable: "custom"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_vm._v(" " + _vm._s(scope.row.invitation_success_rate) + "% ")];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "last_month_invite_count",
      label: "上月开发",
      width: "120",
      sortable: "custom"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "上月留存",
      width: "120",
      prop: "last_month_retention_rate",
      sortable: "custom"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_vm._v(" " + _vm._s(scope.row.last_month_retention_rate) + "% ")];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "上月应结",
      width: "120",
      prop: "last_month_settlement",
      sortable: "custom"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        var _scope$row2;
        return [_vm._v(" " + _vm._s("¥ " + (((_scope$row2 = scope.row) === null || _scope$row2 === void 0 ? void 0 : _scope$row2.last_month_settlement) || 0)) + " ")];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "本月开发",
      width: "120",
      prop: "current_month_invite_count",
      sortable: "custom"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "活跃时间",
      width: "120",
      prop: "last_active_time",
      sortable: "custom"
    }
  }), _c("el-table-column", {
    attrs: {
      width: "120",
      prop: "opened_time",
      label: "开通时间"
    }
  }), _c("el-table-column", {
    attrs: {
      fixed: "right",
      label: "操作",
      width: "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("el-button", {
          attrs: {
            size: "mini",
            type: "text"
          },
          on: {
            click: function click($event) {
              return _vm.toLog(scope.row);
            }
          }
        }, [_vm._v("邀请记录 ")]), _c("el-button", {
          attrs: {
            size: "mini",
            type: "text"
          },
          on: {
            click: function click($event) {
              return _vm.edit(scope.row);
            }
          }
        }, [_vm._v("修改 ")]), _c("el-button", {
          staticClass: "wlc-button-danger",
          attrs: {
            size: "mini",
            type: "text"
          },
          on: {
            click: function click($event) {
              return _vm.deleteItem(scope.row);
            }
          }
        }, [_vm._v("取消 ")])];
      }
    }])
  })], 1), _c("div", {
    staticClass: "wlc-pagination"
  }, [_c("el-pagination", {
    attrs: {
      layout: "total, prev, pager, next",
      "page-size": _vm.searchForm.count,
      "current-page": _vm.searchForm.page,
      total: _vm.total
    },
    on: {
      "current-change": _vm.pageChange
    }
  })], 1), _c("el-dialog", {
    attrs: {
      title: "".concat(this.form.id ? "编辑" : "新增", "\u57CE\u5E02\u5927\u4F7F"),
      visible: _vm.dialogVisible,
      width: "400px"
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.dialogVisible = $event;
      }
    }
  }, [_c("el-form", {
    ref: "cityMasterForm",
    attrs: {
      "label-width": "80px",
      model: _vm.form,
      rules: _vm.rules
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "手机号",
      prop: "phone"
    }
  }, [_c("el-input", {
    attrs: {
      maxLength: "11",
      placeholder: "请输入手机号码",
      disabled: this.form.id
    },
    model: {
      value: _vm.form.phone,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "phone", $$v);
      },
      expression: "form.phone"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "类型",
      prop: "type"
    }
  }, [_c("el-select", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      placeholder: "请选择"
    },
    model: {
      value: _vm.form.type,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "type", $$v);
      },
      expression: "form.type"
    }
  }, _vm._l(_vm.typeList, function (item) {
    return _c("el-option", {
      key: item.value,
      attrs: {
        label: item.label,
        value: item.value
      }
    });
  }), 1)], 1), _c("el-form-item", {
    attrs: {
      label: "等级"
    }
  }, [_c("el-select", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      placeholder: "请选择"
    },
    model: {
      value: _vm.form.level,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "level", $$v);
      },
      expression: "form.level"
    }
  }, _vm._l(_vm.levelList, function (item) {
    return _c("el-option", {
      key: item.value,
      attrs: {
        label: item.value ? item.label : "暂不选择",
        value: item.value
      }
    });
  }), 1)], 1), _c("el-form-item", {
    attrs: {
      label: "备注"
    }
  }, [_c("el-input", {
    attrs: {
      type: "text",
      placeholder: "请输入",
      maxlength: "30",
      "show-word-limit": ""
    },
    model: {
      value: _vm.form.remark,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "remark", $$v);
      },
      expression: "form.remark"
    }
  })], 1)], 1), _c("div", {
    staticClass: "dialog-footer",
    attrs: {
      slot: "footer"
    },
    slot: "footer"
  }, [_c("el-button", {
    on: {
      click: function click($event) {
        _vm.dialogVisible = false;
      }
    }
  }, [_vm._v("取 消")]), _c("el-button", {
    attrs: {
      type: "primary",
      loading: _vm.btnCityMasterLoading
    },
    on: {
      click: _vm.setCityMaster
    }
  }, [_vm._v("确 定 ")])], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };